module.exports = __webpack_public_path__ + "img/gzc.2d9ef9da.png";